import SubMenuError from '@/components/remote/error/SubMenuError.vue'
import SubMenuSkeleton from '@/components/remote/skeleton/SubMenuSkeleton.vue'
import { defineAsyncComponent, type App } from 'vue'
import { useRoute, useRouter, type Router } from 'vue-router'

/**
 * Initialize the microfrontend in async way, set pinia,
 */
export async function initliazeMF(boot: any, ...args: Array<any>) {
    if (!boot.default.initModuleFederation) {
        console.error('Error while try to initialize the microforntends, check the path')
        throw new Error('Init')
    }

    const mfInitRes = boot.default.initModuleFederation(...args)

    if (mfInitRes) {
        console.info('Mf connection is successfull', mfInitRes.name, mfInitRes.version)
    } else {
        console.info('Mf connection is successfull, but not has any response')
    }
}

/**
 * Take the dependecies of the camapign manager MF, registrate the necessary stuff.
 */
export async function initializeCampaignManagerMf(options: {
    app: App
    pinia: any
    i18n: any
    router: Router
}) {
    options.app.component(
        'CampaignManagerSubMenu',
        defineAsyncComponent({
            // the loader function
            loader: async () => import('campaignmanagermf/menu/CampaignManagerSubMenu'),
            // A component to use while the async component is loading
            loadingComponent: SubMenuSkeleton,
            // Delay before showing the loading component. Default: 200ms.
            delay: 200,
            // A component to use if the load fails
            errorComponent: SubMenuError,
            // The error component will be displayed if a timeout is
            // provided and exceeded. Default: Infinity.
            timeout: 3000
        })
    )

    try {
        return initliazeMF(
            await import('campaignmanagermf/boot'),
            options.app,
            options.pinia,
            options.router,
            options.i18n,
            { route: useRoute, router: useRouter }
        )
    } catch (e) {
        console.log('e', e)
        return {
            name: 'Uninitialized-CampaignManagerMF',
            version: -1
        }
    }
}

/**
 * Take the dependecies of the player MF, registrate the necessary stuff.
 */
export async function initializePlayerManagerMf(options: {
    app: App
    pinia: any
    i18n: any
    router: Router
}) {
    options.app.component(
        'PlayerManagerSubMenu',
        defineAsyncComponent({
            // the loader function
            loader: async () => import('playermanagermf/menu/PlayerManagerSubMenu'),
            // A component to use while the async component is loading
            loadingComponent: SubMenuSkeleton,
            // Delay before showing the loading component. Default: 200ms.
            delay: 200,
            // A component to use if the load fails
            errorComponent: SubMenuError,
            // The error component will be displayed if a timeout is
            // provided and exceeded. Default: Infinity.
            timeout: 3000
        })
    )

    try {
        return initliazeMF(
            await import('playermanagermf/boot'),
            options.app,
            options.pinia,
            options.router,
            options.i18n,
            { route: useRoute, router: useRouter }
        )
    } catch (e) {
        console.log('e', e)
        return {
            name: 'Uninitialized-PlayerManagerMF',
            version: -1
        }
    }
}

export async function initializeHiveManagerMf(options: {
    app: App
    pinia: any
    i18n: any
    router: Router
}) {
    options.app.component(
        'HiveManagerSubMenu',
        defineAsyncComponent({
            // the loader function
            loader: async () => import('hivemanagermf/menu/HiveManagerSubMenu'),
            // A component to use while the async component is loading
            loadingComponent: SubMenuSkeleton,
            // Delay before showing the loading component. Default: 200ms.
            delay: 200,
            // A component to use if the load fails
            errorComponent: SubMenuError,
            // The error component will be displayed if a timeout is
            // provided and exceeded. Default: Infinity.
            timeout: 3000
        })
    )

    try {
        return initliazeMF(
            await import('hivemanagermf/boot'),
            options.app,
            options.pinia,
            options.router,
            options.i18n,
            { route: useRoute, router: useRouter }
        )
    } catch (e) {
        console.log('e', e)
        return {
            name: 'Uninitialized-HiveManagerMF',
            version: -1
        }
    }
}

export async function initializeFileManagerMf(options: {
    app: App
    pinia: any
    i18n: any
    router: Router
}) {
    options.app.component(
        'FileManagerSubMenu',
        defineAsyncComponent({
            // the loader function
            loader: async () => import('filemanagermf/menu/FileManagerSubMenu'),
            // A component to use while the async component is loading
            loadingComponent: SubMenuSkeleton,
            // Delay before showing the loading component. Default: 200ms.
            delay: 200,
            // A component to use if the load fails
            errorComponent: SubMenuError,
            // The error component will be displayed if a timeout is
            // provided and exceeded. Default: Infinity.
            timeout: 3000
        })
    )

    try {
        return initliazeMF(
            await import('filemanagermf/boot'),
            options.app,
            options.pinia,
            options.router,
            options.i18n,
            { route: useRoute, router: useRouter }
        )
    } catch (e) {
        console.log('e', e)
        return {
            name: 'Uninitialized-FileManagerMF',
            version: -1
        }
    }
}

export async function initializeUserManagerMf(options: {
    app: App
    pinia: any
    i18n: any
    router: Router
}) {
    options.app.component(
        'UserManagerSubMenu',
        defineAsyncComponent({
            // the loader function
            loader: async () => import('usermanagermf/menu/UserManagerSubMenu'),
            // A component to use while the async component is loading
            loadingComponent: SubMenuSkeleton,
            // Delay before showing the loading component. Default: 200ms.
            delay: 200,
            // A component to use if the load fails
            errorComponent: SubMenuError,
            // The error component will be displayed if a timeout is
            // provided and exceeded. Default: Infinity.
            timeout: 3000
        })
    )

    try {
        return initliazeMF(
            await import('usermanagermf/boot'),
            options.app,
            options.pinia,
            options.router,
            options.i18n,
            { route: useRoute, router: useRouter }
        )
    } catch (e) {
        console.log('e', e)
        return {
            name: 'Uninitialized-UserManagerMF',
            version: -1
        }
    }
}

export async function initializeNotificationManagerMf(options: {
    app: App
    pinia: any
    i18n: any
    router: Router
}) {
    options.app.component(
        'NotificationManagerSubMenu',
        defineAsyncComponent({
            // the loader function
            loader: async () => import('notificationmanagermf/menu/NotificationManagerSubMenu'),
            // A component to use while the async component is loading
            loadingComponent: SubMenuSkeleton,
            // Delay before showing the loading component. Default: 200ms.
            delay: 200,
            // A component to use if the load fails
            errorComponent: SubMenuError,
            // The error component will be displayed if a timeout is
            // provided and exceeded. Default: Infinity.
            timeout: 3000
        })
    )

    try {
        return initliazeMF(
            await import('notificationmanagermf/boot'),
            options.app,
            options.pinia,
            options.router,
            options.i18n,
            { route: useRoute, router: useRouter }
        )
    } catch (e) {
        console.log('e', e)
        return {
            name: 'Uninitialized-NotificationManagerMF',
            version: -1
        }
    }
}

export async function initializeSiteManagerMf(options: {
    app: App
    pinia: any
    i18n: any
    router: Router
}) {
    options.app.component(
        'SiteManagerSubMenu',
        defineAsyncComponent({
            // the loader function
            loader: async () => import('sitemanagermf/menu/SiteManagerSubMenu'),
            // A component to use while the async component is loading
            loadingComponent: SubMenuSkeleton,
            // Delay before showing the loading component. Default: 200ms.
            delay: 200,
            // A component to use if the load fails
            errorComponent: SubMenuError,
            // The error component will be displayed if a timeout is
            // provided and exceeded. Default: Infinity.
            timeout: 3000
        })
    )

    try {
        return initliazeMF(
            await import('sitemanagermf/boot'),
            options.app,
            options.pinia,
            options.router,
            options.i18n,
            { route: useRoute, router: useRouter }
        )
    } catch (e) {
        console.log('e', e)
        return {
            name: 'Uninitialized-SiteManagerMF',
            version: -1
        }
    }
}
